export default "__VITE_ASSET__20232928__"